// Libs
import React from 'react';

// Components
import DeviceView from './DeviceView';
import DesktopView from './DesktopView';

// Hooks
import useListContent from './useListContent';

const ListContent = ({
  product,
  order,
  orderItem,
  isRecurring = false,
  addressesCount = 1,
}) => {
  const { isMobileMode, isTabletMode, ...listContentProps } = useListContent({
    product,
    order,
    orderItem,
    isRecurring,
    addressesCount,
  });

  const viewProps = {
    product,
    order,
    orderItem,
    isRecurring,
    addressesCount,
    isMobileMode,
    isTabletMode,
    ...listContentProps,
  };

  return isMobileMode || isTabletMode ? (
    <DeviceView {...viewProps} />
  ) : (
    <DesktopView {...viewProps} />
  );
};

export default ListContent;
